import React from 'react';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import classNames from 'classnames';

interface SideMenuProps {
  title: string;
  items: { href: string; name: string }[];
}

const SideMenu: React.FC<SideMenuProps> = ({ title, items }) => {
  const { t } = useTranslation();
  const router = useRouter();
  const section: false | HTMLElement | null =
    typeof window !== 'undefined' && document.getElementById('setup-config');

  const scrollToTabStart = () => {
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="side-menu">
      <div className="side-menu-title">{title}</div>
      <div className="swiper-container">
        <div className="swiper-wrapper">
          {items.map((navItem) => {
            const itemActive = navItem.href === router.asPath;
            return (
              <div
                className={classNames('swiper-slide', {
                  active: itemActive,
                })}
                key={navItem.name}
                onClick={scrollToTabStart}
              >
                {!itemActive && (
                  <Link href={navItem.href} scroll={false}>
                    {t(navItem.name)}
                  </Link>
                )}
                {itemActive && t(navItem.name)}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SideMenu;
